import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input, Button } from 'reactstrap';
import { getIdData as getLessonData, addData, updateData } from '../../lib/studentlessons';
import { getIdData as getStudentInfo } from '../../lib/studentinfo';
import { LessonTypeSelect } from '../Common/FormSelects';

const LessonForGradeModal = ({ isOpen, toggle, studentId, lessonToEdit, onSave }) => {
    const [lessonType, setLessonType] = useState(null);
    const [lessonName, setLessonName] = useState('');
    const [isActive, setIsActive] = useState(true);
    const [studentClass, setStudentClass] = useState(null);
    const [loading, setLoading] = useState(false);
    const [initialLoading, setInitialLoading] = useState(false);

    const isEdit = !!lessonToEdit;

    useEffect(() => {
        if (isOpen) {
            fetchInitialData();
            if (isEdit) {
                fetchLessonData();
            } else {
                setLessonType(null);
                setLessonName('');
                setIsActive(true);
            }
        }
    }, [isOpen, lessonToEdit]);

    const fetchInitialData = async () => {
        try {
            setInitialLoading(true);
            const studentInfo = await getStudentInfo(studentId);
            if (studentInfo && studentInfo.length > 0) {
                setStudentClass(studentInfo[0]?.class ?? null);
            }
        } catch (error) {
            console.error('Error fetching student class information:', error);
        } finally {
            setInitialLoading(false);
        }
    };

    const fetchLessonData = async () => {
        try {
            setLoading(true);
            const lessonData = await getLessonData(lessonToEdit.id);
            if (lessonData && lessonData.length > 0) {
                setLessonName(lessonData[0].lessonName);
                setIsActive(lessonData[0].isActive);
                setLessonType(lessonData[0].lessonType);
            }
        } catch (error) {
            console.error('Error fetching lesson data:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            if (!isEdit) {
                await addData({
                    class: studentClass,
                    lessonName: lessonName,
                    isActive: isActive,
                    studentId: studentId,
                    lessonType: lessonType
                });
            } else {
                await updateData({
                    id: lessonToEdit.id,
                    lessonName: lessonName,
                    isActive: isActive,
                    lessonType: lessonType
                });
            }
            onSave(isEdit ? 'Course updated successfully!' : 'Course added successfully!');
            toggle();
        } catch (error) {
            console.error('Error saving lesson:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} size="lg">
            <ModalHeader toggle={toggle}>
                {isEdit ? 'Update Course' : 'Add New Course'}
            </ModalHeader>
            <ModalHeader toggle={toggle}>
                {isEdit ? 'Update Course' : 'Add New Course'}
            </ModalHeader>
            <ModalBody>
                {initialLoading ? (
                    <div className="text-center p-4">
                        <div className="spinner-border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                ) : (
                    <Form onSubmit={handleSubmit} id="lesson-grade-form">
                        <FormGroup className="mb-3">
                            <Label className="form-control-label fw-bold">Department</Label>
                            <LessonTypeSelect value={lessonType} setValue={setLessonType} />
                        </FormGroup>

                        <FormGroup className="mb-3">
                            <Label className="form-control-label fw-bold">Course Name</Label>
                            <Input
                                type="text"
                                value={lessonName}
                                onChange={(e) => setLessonName(e.target.value)}
                                className="form-control"
                                placeholder="Enter Course Name"
                                required
                            />
                        </FormGroup>

                        <FormGroup className="mb-3">
                            <Label className="form-control-label fw-bold">Is Active</Label>
                            <div className="form-check form-switch">
                                <Input
                                    className="form-check-input"
                                    type="checkbox"
                                    checked={isActive}
                                    onChange={(e) => setIsActive(e.target.checked)}
                                    style={{ cursor: 'pointer' }}
                                />
                                <Label className="form-check-label ms-2">{isActive ? 'Active' : 'Inactive'}</Label>
                            </div>
                        </FormGroup>
                    </Form>
                )}
            </ModalBody>
            <ModalFooter>
                <Button color="primary" type="submit" form="lesson-grade-form" disabled={loading || initialLoading}>
                    <i className="fa fa-save me-2"></i>
                    {loading ? 'Saving...' : isEdit ? 'Update Course' : 'Add Course'}
                </Button>
                <Button color="secondary" onClick={toggle} disabled={loading}>
                    <i className="fa fa-times me-2"></i>
                    Cancel
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default LessonForGradeModal;
